import type { FunctionComponent } from 'react';

import type { StandardTextFieldProps } from '@material-ui/core/TextField'

import { TextFieldStyled } from './styles/TextFieldStyled'

export interface ITextFieldProps extends StandardTextFieldProps {
  /**
   * Unique identifier for analytics tracking of text field interactions.
   */
  analyticsId?: string
}

// Styled Material TextField
export const TextField: FunctionComponent<ITextFieldProps> = (props) => (
  <TextFieldStyled {...(props as any)} />
)

TextField.displayName = 'TextField'
